import { name } from "@azure/msal-browser/dist/packageMetadata";

const jsonSchema = [
  {
    type: 'group',
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true, showInList: true },
      {
        name: 'type',
        label: 'Type',
        type: 'multiselect',
        required: true,
        showInList: true
      },
      {
        name: 'capacity',
        label: 'Capacity',
        type: 'number',
        required: true,
        showInList: true
      }
    ]
  },
  {
    name: 'facilities',
    label: 'Facilities',
    type: 'creatableselect',
    required: false,
    showInList: false,
    isMulti: true
  }  
];
export default jsonSchema;  